/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { NonEmptyText } from './non-empty-text';

// TODO: Add validation for source
export const Source = NonEmptyText;

export type Source = z.infer<typeof Source>;
